import { Link } from 'react-router-dom';
import image from "../../../assets/img/page/image-1.png";

const Experience = () => {
    return (
        <div className="experience__area section-padding pt-0">
            <div className="container">
                <div className="row al-center">
                    
                    {/* Changed to col-lg-7 and added md-mb-50 for mobile spacing */}
                    <div className="col-lg-7 col-md-12 pr-40 xl-pr-10 md-mb-50 lg-mb-40">
                        <div className="experience__area-title section-padding pb-0">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Message from the Founder</span>
                            <h2 className="wow fadeInRight" data-wow-delay=".6s">Aakash Vaghela</h2>
                        </div>
                        <div className="row mt-40">
                            <div className="col-md-12 wow fadeInLeft" data-wow-delay=".6s">
                                <blockquote style={{ 
                                    fontSize: '1.25rem', 
                                    fontStyle: 'italic', 
                                    lineHeight: '1.8', 
                                    borderLeft: '4px solid #ff5e14', 
                                    paddingLeft: '20px',
                                    color: '#ffffff',
                                    margin: '0'
                                }}>
                                    “At Arclight Developers, we believe that every road, line, and we build should stand as a mark of responsibility, quality, and long-term value. Our mission is to contribute meaningful infrastructure work that supports development and serves communities with strength and trust.”
                                </blockquote>
                            </div>
                        </div>
                    </div>

                    {/* Changed to col-lg-5 for better proportions */}
                    <div className="col-lg-5 col-md-12">
                        {/* Centered the image wrapper */}
                        <div className="experience__area-image" style={{ textAlign: 'center' }}>
                            <img 
                                className="wow img_top_animation" 
                                src={image} 
                                alt="Founder Aakash Vaghela" 
                                style={{ 
                                    borderRadius: '15px', 
                                    width: '100%', // Forces the image to shrink on mobile
                                    maxWidth: '450px', // Stops it from getting too huge on large monitors
                                    height: 'auto', // Maintains the portrait aspect ratio
                                    objectFit: 'cover',
                                    boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.4)' // Adds a professional drop shadow
                                }} 
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Experience;